import { useState, useEffect } from 'react'

import { useEventCapture } from '@surglogs-app/analytics'
import { useHandler } from '@surglogs-app/hooks'
import { useAuthMfaSetupInitiatePostMutation } from '@surglogs-app/network'
import { useToast } from '@surglogs-app/ui.toast'

interface UseInitiateMfaSetupProps {
  transactionId: string
  context: 'account' | 'settings'
}

export const useInitiateMfaSetup = ({
  transactionId,
  context,
}: UseInitiateMfaSetupProps) => {
  const { captureEvent } = useEventCapture()
  const { showErrorToast } = useToast()

  const [secretCode, setSecretCode] = useState<string>('')

  const { mutateAsync, isPending } = useAuthMfaSetupInitiatePostMutation()

  const initiateMFASetup = useHandler(async () => {
    try {
      const response = await mutateAsync({ transaction_id: transactionId })
      captureEvent('mfa_setup_initiated', { context })
      setSecretCode(response.secret_code)
    } catch (error) {
      showErrorToast({ error })
    }
  })

  useEffect(() => {
    initiateMFASetup()
  }, [initiateMFASetup])

  return { secretCode, isPending, initiateMFASetup }
}
